export default __webpack_public_path__ + "static/media/logo0.e3c8984e.png";